// extracted by mini-css-extract-plugin
export default {"privacyWrap":"Privacy_privacyWrap__-Sb68","date":"Privacy_date__+07X9"};